import { Input, InputProps } from 'antd';
import { SearchProps } from 'antd/lib/input/Search';
import { TextAreaProps } from 'antd/lib/input/TextArea';
import clsx from 'classnames';
import React, { FC, useState } from 'react';
import './index.scss';

const SearchSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
    <g clipPath="url(#clip0_491_87858)">
      <path fillRule="evenodd" clipRule="evenodd" d="M11.8 7.5C11.8 9.87482 9.87483 11.8 7.50001 11.8C5.12518 11.8 3.20001 9.87482 3.20001 7.5C3.20001 5.12518 5.12518 3.2 7.50001 3.2C9.87483 3.2 11.8 5.12518 11.8 7.5ZM11.0186 11.7274C10.065 12.522 8.83832 13 7.50001 13C4.46244 13 2.00001 10.5376 2.00001 7.5C2.00001 4.46243 4.46244 2 7.50001 2C10.5376 2 13 4.46243 13 7.5C13 8.7669 12.5717 9.93375 11.8519 10.8636L13.6577 12.6694C13.892 12.9038 13.892 13.2837 13.6577 13.518C13.4234 13.7523 13.0435 13.7523 12.8092 13.518L11.0186 11.7274Z" />
    </g>
    <defs>
      <clipPath id="clip0_491_87858">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const { Search, TextArea } = Input;

export const TdsInput: FC<InputProps> = (props) => {
  const { className, children, ...rest } = props;
  return (
    <Input className={clsx('tds-input', className)} {...rest}>
      {children}
    </Input>
  );
};

export const TdsSearch: FC<SearchProps> = (props) => {
  const { className, children, onSearch, onChange, ...rest } = props;
  const [keyword, setKeyword] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setKeyword(e.target.value);
    onChange?.(e);
  };

  return (
    <Search
      className={clsx('tds-input tds-search', className)}
      {...rest}
      onChange={handleChange}
      onSearch={onSearch}
      suffix={<div style={{ display: 'flex' }} onClick={() => onSearch?.(keyword)}>
        <SearchSvg />
      </div>}
    >
      {children}
    </Search>
  );
};

export const TdsTextArea: FC<TextAreaProps> = (props) => {
  const { className, children, ...rest } = props;
  return (
    <TextArea className={clsx('tds-input tds-textarea', className)} {...rest}>
      {children}
    </TextArea>
  );
};
